



































import { Loading } from 'element-ui';
import _get from 'lodash/get';

import { Component, Prop, Vue } from 'vue-property-decorator';
import menuApi from '@/api/menu';
import { addPagePath } from '@/utils/index';
import { Page } from '@/types';
import { RedactModule } from '@/store/modules/redact';
import { UserModule } from '@/store/modules/user';
import { Role } from '../../api/types';

@Component
export default class Tree extends Vue {
  private defaultProps: any = {
    children: 'subs',
    label: 'name',
  };

  get isStaff() {
    return UserModule.jaccountId && UserModule.jaccountType === 'staff';
  }

  private activeNode: string = '';

  thirdLevelWrapperHeight: number = 0;

  get loadingPages() {
    return RedactModule.loadingPages;
  }

  get pages() {
    return RedactModule.pages;
  }

  get userAuths() {
    return UserModule.auths;
  }

  get isSuperadmin() {
    return UserModule.role === Role.SUPERADMIN;
  }

  created() {
    if (UserModule.jaccountType === 'teacher') {
      this.$router.push({
        path: '/profile',
      });
    }
  }

  mounted() {
    RedactModule.GetPages();
  }

  private handleNodeClick(data: Page) {
    if (data.subs.length > 0) {
      if (this.activeNode === data.path + '-' + data.name) {
        this.activeNode = '';
      } else {
        this.activeNode = data.path + '-' + data.name;
      }
      this.$nextTick(() => {
        if (_get(this.$refs, 'thirdLevelWrapper.0')) {
          this.thirdLevelWrapperHeight = this.$refs.thirdLevelWrapper![0]!.offsetHeight - 20;
        }
      });
      return;
    }
    // 图文编排页面
    if (data.type === 'html') {
      return this.$router.push({
        path: '/redact/htmlPage',
        query: { path: data.path, name: data.name },
      });
    }
    // 列表页面
    if (data.type === 'list') {
      return this.$router.push({
        path: '/redact/listPage',
        query: { path: data.path },
      });
    }
  }
}
